<ul class="p-0">
    @for (item of props.items; track item.id; let i = $index) {
        <li [ngClass]="{ 'active': i === selectedIndex }" (click)="selectItem(i)" data-id="{{item.id}}" class="tags-box" role="option"><p>{{item.name}}</p><p>Insert a new<span class="content-builder-menu-inner-label">Tag</span></p></li>
    }
</ul>